/*****************************************
 * * IMPORTS
 *****************************************/
// React libraries
import React, { Component } from 'react';

// styles and images
import styles from './Canvas.module.css';

// components

/*****************************************
 * * CREATE COMPONENT
 *****************************************/
class Canvas extends Component {
  state = {
    canvasWidth: this.props.size.width || 10,
    canvasHeight: this.props.size.height || 10,
  };
  // after component is rendered
  componentDidMount = () => {
    let canvas = this.refs.canvas;

    this.ctx = canvas.getContext('2d');

    // set canvas physical size
    this.setState({
      canvasWidth: canvas.offsetWidth,
      canvasHeight: canvas.offsetHeight,
    });
    // size of image
    this.size = this.props.size;
  };

  componentDidUpdate() {
    let canvas = this.refs.canvas;

    let imgWidth = this.size.width;
    let imgHeight = this.size.height;
    const hRatio = canvas.width / imgWidth;
    const vRatio = canvas.height / imgHeight;
    const ratio = Math.max(hRatio, vRatio); // full image 
    // const ratio = Math.max(hRatio, vRatio); // fill full canvas area
    const centerShift_x = (canvas.offsetWidth - imgWidth * ratio) / 2;
    const centerShift_y = (canvas.offsetHeight - imgHeight * ratio) / 2;

    this.ctx.clearRect(0, 0, canvas.offsetWidth, canvas.offsetHeight);
    if (!this.props.image) {
      if (this.props.matrix === null) {
        return;
      }
      let imageData = this.ctx.createImageData(imgWidth, imgHeight);

      this.props.matrix.forEach((el, idx) => (imageData.data[idx] = el));

      // Update the canvas with the new data
      // ctx.putImageData(imgData, canvasX, canvasY, srcX ,srcY, srcWidth, srcHeight);

      this.ctx.putImageData(
        imageData,
        centerShift_x,
        centerShift_y,
        0,
        0,
        Math.floor(imgWidth * ratio),
        Math.floor(imgHeight * ratio),
      );
    } else {
      // this.ctx.clearRect(0, 0, canvas.width, canvas.height);

      let img = new Image();
      img.src = this.props.src;
      // console.log(img.src)


      // console.log(canvas.width, canvas.height, img.width, img.height);

      let imgData;
      
      img.onload = () => {
        imgWidth = Math.floor(img.width * ratio);
        imgHeight = Math.floor(img.height * ratio);
        this.ctx.drawImage(
          img,
          0,
          0,
          img.width,
          img.height,
          centerShift_x,
          centerShift_y,
          imgWidth,
          imgHeight,
        );

        imgData = this.ctx.getImageData(
          centerShift_x,
          centerShift_y,
          imgWidth,
          imgHeight,
        );

        this.props.onImgLoad(imgData.data, imgWidth, imgHeight);
      };
    }
  }

  render() {
    return (
      <>
        {/* <div className={styles.heading}>{this.props.title}</div> */}
        <canvas
          ref='canvas'
          width={this.state.canvasWidth}
          height={this.state.canvasHeight}
          className={styles.frame + ' ' + styles[this.props.className]}
        />
      </>
    );
  }
}

export default Canvas;
